// Fields
export const ACCOUNT = "account";
export const TITLE = "title";
export const NAME = "name";
export const SIGNATURE = "signature";
export const LOGO = "logo";
export const ALL_ACCOUNTS = "allAccounts";
export const AGREE = "agree";
export const FIELDS = [ACCOUNT, TITLE, NAME, SIGNATURE, LOGO, ALL_ACCOUNTS];
export const SIGNATURE_IMAGE_DEFAULT_NAME = "Signature Uploaded";
export const LOGO_IMAGE_DEFAULT_NAME = "Logo Uploaded";
